import React, { Fragment, useState } from 'react';
import { useIntl } from 'react-intl';
import Popover from 'material-ui/Popover';

import Icon from '../../../Icon';

import styles from './styles.module.styl';

const PaymentMethodsHint = () => {
  const [anchorEl, setAnchorEl] = useState(null);

  const { formatMessage } = useIntl();

  const open = Boolean(anchorEl);

  const hintText = formatMessage({ id: 'profile.payment.hint' });

  const handleOpen = e => setAnchorEl(e.currentTarget);
  const handleClose = () => setAnchorEl(null);

  return (
    <Fragment>
      <Icon
        name="icon-info"
        size={16}
        className={styles.infoIcon}
        onClick={handleOpen}
      />

      <Popover
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
        transformOrigin={{ vertical: 'top', horizontal: 'left' }}
        disableRestoreFocus
      >
        <div className={styles.hintText}>{hintText}</div>
      </Popover>
    </Fragment>
  );
};

export default PaymentMethodsHint;



// WEBPACK FOOTER //
// ./src/components/ProfileLayout/ProfilePaymentMethods/PaymentMethodsHint/index.jsx